import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import OpenNotification from 'src/app/components/antd/OpenNotification';

import { apiCancellationFunnels } from '../../api';
import { SpecialistFormData } from '../../types/specialistPageTypings';
import { specialistFunnelsPagesFactory } from '../../utils/specialistFunnelsPagesFactory';

interface UpdateSpecialistFunnelPageRequest {
  id: string;
  payload: SpecialistFormData;
}

export function useTryToRequestUpdateSpecialistFunnelPage() {
  const navigate = useNavigate();

  const { mutateAsync, isPending: isLoading } = useMutation({
    mutationFn: async ({ id, payload }: UpdateSpecialistFunnelPageRequest) => {
      const body = specialistFunnelsPagesFactory(payload);

      return await apiCancellationFunnels.tryToRequestUpdateCancellationFunnelPage(
        id,
        body
      );
    },
    onSuccess: () => {
      navigate(-1);
    },
    onError: () => {
      OpenNotification(
        true,
        'Erro ao editar o funil de Atendimento Especialista',
        'Ocorreu um erro ao editar o funil de Atendimento Especialista, por favor tente novamente mais tarde.'
      );
    },
  });

  return { tryToRequestUpdateSpecialistFunnelPage: mutateAsync, isLoading };
}
